import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import 'bootstrap/dist/css/bootstrap.min.css';

import AutoButton from '../../../AutoButton';
import TextInput from '../../../Form/TextInput';
import Textarea from '../../../Form/Textarea';
import closeIcon from '../../../../assets/images/dashboard/close.svg';
import classes from './styles.module.scss';

export default function SaveSearchModal({
  show,
  handleClose,
  onSave,
  projects = [],
  initialName = '',
  initialDescription = '',
  initialProjectId = null,
}) {
  const { t } = useTranslation();
  const [name, setName] = useState(initialName);
  const [description, setDescription] = useState(initialDescription);
  const [projectId, setProjectId] = useState(initialProjectId);

  useEffect(() => {
    if (show) {
      setName(initialName);
      setDescription(initialDescription);
      setProjectId(initialProjectId);
    }
  }, [show, initialName, initialDescription, initialProjectId]);

  const handleSave = () => {
    if (!name.trim()) return;

    onSave({
      name: name.trim(),
      description: description.trim(),
      projectId: projectId || null,
    });

    // Reset form
    setName('');
    setDescription('');
    setProjectId(null);
  };

  const handleCancel = () => {
    setName('');
    setDescription('');
    setProjectId(null);
    handleClose();
  };

  return (
    <Modal
      show={show}
      onHide={handleCancel}
      centered
      className={classes.SaveSearchModal}
      backdropClassName={classes.backdrop}
      contentClassName={classes.modalContent}
      dialogClassName={classes.dialog}
    >
      <div className={classes.content}>
        <header className={classes.header}>
          <h1 className={classes.title}>
            {t('intelSearch.saveSearchModal.title')}
          </h1>
          <button
            type="button"
            className={classes.closeButton}
            onClick={handleCancel}
          >
            <img src={closeIcon} alt="Close" />
          </button>
        </header>

        <p className={classes.subtitle}>
          {t('intelSearch.saveSearchModal.subtitle')}
        </p>

        <div className={classes.form}>
          <TextInput
            name="search-name"
            label={t('intelSearch.saveSearchModal.nameLabel')}
            placeholder={t('intelSearch.saveSearchModal.namePlaceholder')}
            value={name}
            onChange={(e) => setName(e.target.value)}
            maxLength={50}
            height={45}
          />

          <Textarea
            name="search-description"
            label={t('intelSearch.saveSearchModal.descriptionLabel')}
            placeholder={t(
              'intelSearch.saveSearchModal.descriptionPlaceholder'
            )}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            maxLength={200}
            height={80}
          />

          {projects.length > 0 && (
            <div className={classes.field}>
              <label htmlFor="search-project">
                {t('intelSearch.saveSearchModal.projectLabel')}
              </label>
              <select
                id="search-project"
                value={projectId || ''}
                onChange={(e) => setProjectId(e.target.value || null)}
              >
                <option value="">
                  {t('intelSearch.saveSearchModal.noProject')}
                </option>
                {projects.map((project) => (
                  <option key={project.id} value={project.id}>
                    {project.name}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <div className={classes.buttons}>
          <AutoButton variant="black" onClick={handleCancel} height={45}>
            {t('common.cancel')}
          </AutoButton>
          <AutoButton height={45} onClick={handleSave} disabled={!name.trim()}>
            {t('common.save')}
          </AutoButton>
        </div>
      </div>
    </Modal>
  );
}
